import { render, staticRenderFns } from "./PropEditor.vue?vue&type=template&id=057cee02&scoped=true"
import script from "./PropEditor.vue?vue&type=script&lang=ts"
export * from "./PropEditor.vue?vue&type=script&lang=ts"
import style0 from "./PropEditor.vue?vue&type=style&index=0&id=057cee02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057cee02",
  null
  
)

export default component.exports